import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { ContextModel } from '../../projects/fs-bilanci-app/src/app/children/main/children/context/context.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalContextService {
  private _contexts$: BehaviorSubject<ContextModel[]> = new BehaviorSubject<ContextModel[]>([]);
  public contexts$: Observable<ContextModel[]> = this._contexts$.asObservable();

  constructor(
    private flamingoHttpService: FlamingoHttpService,
  ) {
  }

  get contexts(): ContextModel[] {
    return this._contexts$.value;
  }

  getContextConfiguration(context: string): ContextModel | undefined {
    return this.contexts.find(c => c.systemName === context);
  }

  public fetch(): Observable<ContextModel[]> {
    return this.list()
      .pipe(
        tap(items => this._contexts$.next(items.sort((o1, o2) => o1.weight - o2.weight))),
      );
  }

  private list(): Observable<ContextModel[]> {
    return this.flamingoHttpService.get<ContextModel[]>(`/contexts`);
  }
}
